// extracted by mini-css-extract-plugin
module.exports =  {"container":"_025a50318d--container--_Kurq","list":"_025a50318d--list--xc9sY","list-inner":"_025a50318d--list-inner--gJf2A"};